/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { useEffect, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { useApi } from 'app/api/APIProvider';
import { formatNumber } from 'shared/lib/utils/utils';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import cls from './TransactionSum.module.scss';

interface TransactionProps {
    balanceText: string;
    sum: number | string
}

export const TransactionSum = ({ sum, balanceText }: TransactionProps) => {
    const api = useApi();

    return (
        <div className={cls.card}>
            <Text className={cls.title} color="#ffffff" size={TextSize.text_28_600}>{balanceText ? balanceText : "Баланс"}: {formatNumber(Number(sum))} ₽</Text>
        </div>
    );
};

